import Vue from "vue";
import vuetify from "@/plugins/vuetify";
import App from "./App.vue";
import { router } from "./router";
import store from "./store";
import i18n from "./plugins/i18n";
// import VueAnalytics from "vue-analytics";
// import GSignInButton from "vue-google-signin-button";
import * as firebase from "firebase/app";
// import "firebase/auth";
import { AuthRequests, configService } from "./helpers/index";
import axiosInterceptor from "./plugins/axiosInterceptor";

Vue.config.productionTip = false;
// Vue.use(GSignInButton);

let vueApp: Vue | null = null;

const createVueApp = () => {
  return new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
};
/*Vue.use(VueAnalytics, {
  id: configService.googleanalyticsid,
  router
});*/

axiosInterceptor();

firebase
  .initializeApp(configService.firebaseEnv)
  .auth()
  .onAuthStateChanged(() => {
    // console.warn("firebaseUser: ", firebaseUser);
      // User already logged.
      store
        .dispatch("session/autoAuth")
        .then(() => {
          if (!vueApp) {
            vueApp = createVueApp();
          }
        })
        .catch((error: any) => {
          if (error.status === 403)
            store.dispatch("app/setSnackbarMessage", {
              message: i18n.t("login.loginError"),
              color: "red"
            });
        });
    if (vueApp) {
      // App initialized but no login
      router.push("/");
    } else {
      // No user, no App
      vueApp = createVueApp();
    }
  });

// const checkUser = () => {
//   let currentUser = AuthRequests.autoAuthUser();
//   if(currentUser) {
//     // User already logged.
//     store
//       .dispatch("session/autoAuth")
//       .then(() => {
//         if (!vueApp) {
//           vueApp = createVueApp();
//         }
//       })
//       .catch((error: any) => {
//         if (error.status === 403)
//           store.dispatch("app/setSnackbarMessage", {
//             message: i18n.t("login.loginError"),
//             color: "red"
//           });
//       });
//   } else if (vueApp) {
//     // App initialized but no login
//     router.push("/");
//   } else {
//     // No user, no App
//     vueApp = createVueApp();
//   }
// };
//
// checkUser();

